module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-6",
    attrs: {
      "max-width": "500",
      "max-height": "calc(100vh - 150px)"
    }
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('h3', [_vm._v("Nuevo ticket")])]), _c('div', {
    staticClass: "fd-column flex-1"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.tiposTicket,
      "label": "Tipos de ticket",
      "placeholder": "Selecciona una opcion",
      "item-text": "name",
      "return-object": "return-object",
      "item-value": "id",
      "dense": "dense"
    },
    model: {
      value: (_vm.tipoTicketSeleccionado),
      callback: function($$v) {
        _vm.tipoTicketSeleccionado = $$v
      },
      expression: "tipoTicketSeleccionado"
    }
  })], 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1 d-flex"
  }, [_c('v-text-field', {
    ref: "documento",
    attrs: {
      "dense": "dense",
      "type": "number",
      "label": "Numero de contrato",
      "hide-details": "hide-details"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchEquipos()
      }
    },
    model: {
      value: (_vm.numeroContrato),
      callback: function($$v) {
        _vm.numeroContrato = $$v
      },
      expression: "numeroContrato"
    }
  }), _c('v-btn', {
    attrs: {
      "color": "info",
      "block": _vm.isMovil,
      "small": !_vm.isMovil
    },
    on: {
      "click": _vm.fetchEquipos
    }
  }, [_vm._v("buscar")])], 1)]), (_vm.usuariosContrato.length) ? _c('div', {
    staticClass: "d-flex fd-column mt-4"
  }, [_c('span', {
    staticClass: "font-size-11"
  }, [_vm._v("Cuentas registradas para este cliente")]), (_vm.usuarioSeleccionado.length > 1) ? _c('v-radio-group', {
    staticClass: "my-1",
    attrs: {
      "row": "row",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.usuarioSeleccionado),
      callback: function($$v) {
        _vm.usuarioSeleccionado = $$v
      },
      expression: "usuarioSeleccionado"
    }
  }, _vm._l((_vm.usuariosContrato), function(usuario, index) {
    return _c('v-radio', {
      key: index,
      attrs: {
        "label": ((usuario.razonSocial) + " (" + (usuario.usuario) + ")"),
        "value": usuario.usuario,
        "hide-details": "hide-details"
      }
    })
  }), 1) : _c('span', {
    staticClass: "font-size-12 text-muted"
  }, [_vm._v("El ticket se generará con el usuario " + _vm._s(_vm.usuarioSeleccionado))])], 1) : _vm._e(), (_vm.modelosAgrupados.length) ? _c('div', {
    staticClass: "d-flex"
  }, [(!_vm.equiposDelModeloFiltrados.length) ? _c('div', {
    staticClass: "flex-1 mt-4"
  }, [_c('v-autocomplete', {
    attrs: {
      "loading": _vm.isGettingEquipos,
      "items": _vm.modelosAgrupados,
      "label": "Listado de modelos que tienes en contrato",
      "placeholder": "Realiza la busqueda por el modelo",
      "item-value": "modelo",
      "return-object": "return-object",
      "dense": "dense",
      "hide-details": "hide-details"
    },
    on: {
      "change": _vm.seleccionarModelo
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('span', {
          staticClass: "font-weight-700 font-size-12"
        }, [_vm._v(_vm._s(data.item.modelo))])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "font-weight-700",
          domProps: {
            "innerHTML": _vm._s(data.item.modelo)
          }
        }), _c('v-list-item-subtitle', [_c('span', {
          staticClass: "font-size-11 text-muted"
        }, [_vm._v(_vm._s(((data.item.cantidad) + " Equipo(s)")))])])], 1)]
      }
    }], null, false, 3179395255),
    model: {
      value: (_vm.modeloSeleccionado),
      callback: function($$v) {
        _vm.modeloSeleccionado = $$v
      },
      expression: "modeloSeleccionado"
    }
  })], 1) : _vm._e(), (!_vm.serieSeleccionado && _vm.equiposDelModeloFiltrados.length) ? _c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "d-flex ai-center mt-4",
    class: _vm.isMovil && 'fd-column'
  }, [_c('v-btn', {
    class: _vm.isMovil && 'mb-2',
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.limpiarModelo()
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _c('v-autocomplete', {
    staticClass: "mx-4",
    attrs: {
      "items": _vm.equiposDelModeloFiltrados,
      "label": ("Listado de equipos del modelo " + (_vm.modeloSeleccionado.modelo)),
      "placeholder": "Realiza la busqueda por la descripción",
      "dense": "dense",
      "item-value": "serie",
      "item-text": "serie",
      "return-object": "return-object",
      "hide-details": "hide-details"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "font-weight-700",
          domProps: {
            "innerHTML": _vm._s(data.item.serie)
          }
        }), _c('v-list-item-subtitle', [_c('span', {
          staticClass: "font-size-11"
        }, [_vm._v(_vm._s(data.item.descripcionArticulo))])])], 1)]
      }
    }], null, false, 2870585779),
    model: {
      value: (_vm.serieSeleccionado),
      callback: function($$v) {
        _vm.serieSeleccionado = $$v
      },
      expression: "serieSeleccionado"
    }
  })], 1)]) : _vm._e()]) : _vm._e(), (_vm.serieSeleccionado) ? _c('v-card', {
    staticClass: "pa-2 mt-4",
    attrs: {
      "dense": "dense",
      "color": "background"
    }
  }, [_c('v-list-item', [_c('v-list-item-content', {
    staticClass: "py-0"
  }, [_c('v-list-item-title', [_c('small', {
    staticClass: "font-weight-700"
  }, [_vm._v(_vm._s(("#" + (_vm.serieSeleccionado.numeroContrato))) + " -  ")]), _c('small', {
    staticClass: "font-weight-700"
  }, [_vm._v(_vm._s(_vm.serieSeleccionado.modelo) + " -  ")]), _c('small', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v(_vm._s(_vm.serieSeleccionado.serie))])]), _c('v-list-item-subtitle', {
    staticClass: "info--text font-weight-700 font-size-12"
  }, [_vm._v(_vm._s(_vm.serieSeleccionado.descripcionArticulo))]), _c('v-list-item-subtitle', {
    staticClass: "font-weight-700 font-size-12"
  }, [_vm._v(_vm._s(_vm.serieSeleccionado.direccionMaquina) + " - (" + _vm._s(_vm.serieSeleccionado.descripcionUbigeoMaquina) + ")")])], 1), _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "color": "info",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.limpiarSerie()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "17"
    }
  }, [_vm._v("keyboard_arrow_left")])], 1)], 1)], 1)], 1) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex mt-8"
  }, [_c('v-btn', {
    staticClass: "flex-1 mr-5",
    attrs: {
      "color": "primary",
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.limpiarTodo()
      }
    }
  }, [_c('small', [_vm._v("Cancelar")])]), _c('v-btn', {
    staticClass: "flex-1",
    attrs: {
      "color": "success",
      "block": _vm.isMovil,
      "disabled": !_vm.serieSeleccionado
    },
    on: {
      "click": function($event) {
        return _vm.procesoGenerarTickets()
      }
    }
  }, [_c('small', [_vm._v("Registrar")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17df9b3a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_card_generate_ticket.vue
// module id = 480
// module chunks = 1